var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFaqicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 14,
    viewBox: "0 0 29 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.157 13.7072C13.6866 13.7081 13.2308 13.557 12.8686 13.2802L0.789751 3.99669C0.378634 3.68154 0.120098 3.22867 0.0710186 2.73771C0.0219388 2.24675 0.186335 1.75791 0.528043 1.37874C0.86975 0.999575 1.36078 0.76113 1.8931 0.715864C2.42543 0.670599 2.95545 0.822219 3.36657 1.13737L14.157 9.45538L24.9474 1.43445C25.1533 1.28022 25.3903 1.16504 25.6446 1.09554C25.8989 1.02604 26.1657 1.00359 26.4294 1.02947C26.6932 1.05535 26.9488 1.12906 27.1816 1.24635C27.4144 1.36365 27.6198 1.52222 27.7859 1.71295C27.9703 1.90386 28.1099 2.12783 28.1961 2.37082C28.2822 2.61381 28.313 2.87059 28.2866 3.12508C28.2601 3.37956 28.1769 3.62627 28.0423 3.84973C27.9077 4.0732 27.7244 4.26861 27.5041 4.42373L15.4253 13.3916C15.0527 13.6246 14.6061 13.7358 14.157 13.7072Z",
    fill: "url(#paint0_linear_738_772)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_738_772",
    x1: 14.1791,
    y1: 3.69699,
    x2: 14.1791,
    y2: 11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8A50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8A50"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaqicon);
export default __webpack_public_path__ + "static/media/Faqicon.8a2b41fa53c99ea30922d0c660e25514.svg";
export { ForwardRef as ReactComponent };